import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar-logo',
  standalone: true,
  templateUrl: './navbar-logo.component.svg',
  styleUrls: ['./navbar-logo.component.scss'],
})
export class NavbarLogoComponent {}
